import { render } from "./Draft.vue?vue&type=template&id=1e727462&ts=true"
import script from "./Draft.vue?vue&type=script&lang=ts"
export * from "./Draft.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__